import { render } from "./ProjectsView.vue?vue&type=template&id=6292b8b0&scoped=true"
import script from "./ProjectsView.vue?vue&type=script&lang=js"
export * from "./ProjectsView.vue?vue&type=script&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=6292b8b0&scoped=true&lang=css"

import exportComponent from "C:\\Development\\Portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6292b8b0"]])

export default __exports__